var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"QHImgList"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"li",on:{"click":function($event){return _vm.$openImg(item.url, item.name)}}},[_c('Tooltip',{attrs:{"content":item.name,"placement":"top"}},[_c('img',{attrs:{"src":_vm.$httpImg(item.url)}})])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }